"use client"
import React from "react";
import "./tools.scss";
import { SiWhatsapp } from "react-icons/si";
import { FiPhone } from "react-icons/fi";
import { IoMailOutline } from "react-icons/io5";
import { MdSupportAgent } from "react-icons/md";
const Tools = () => {
  return (
    <div className="tool-parent">
      <a href="tel:+18002101999" className="side-whatsapp manage-icons" target="__blank"  >
        <MdSupportAgent  className="whatsapp-icon" />{" "}
        <span className="whatsapp-span">Live Secretary</span>
      </a>
      <a href="mailto:support@axoncare.io" className="side-mail manage-icons" target="__blank" >
        <IoMailOutline className="mail-icon" />{" "}
        <span className="email-span">Enquire Now</span>
      </a>
      <a href="https://wa.me/+918956652833" target="__blank" className="side-phone manage-icons" >
        {" "}
        <SiWhatsapp className="phone-icon" />{" "}
        <span className="phone-span">Chat Now</span>
      </a>

      
    </div>
  );
};

export default Tools;
